import { AuthData } from "../types/auth";

export const isSchoolwideReflectionsDisabled = (
  auth?: AuthData | null,
): boolean =>
  Boolean(auth?.user?.organization?.is_schoolwide_reflections_disabled);
